import { useAppDispatch } from "../../../../../redux/hooks";
import { useNavigate } from "react-router-dom";

import { AssignedCarsNodeDataInterface } from "../../../../../redux/interfaces/fleet.interface";
import CustomButton from "../../../../../components/CustomButton";
import SvgIcon from "../../../../../helpers/SvgIcon";
import { setFleetAssignedCarToNode } from "../../../../../redux/reducer/fleet.reducer";
import { fleetRoutes } from "../../../../../router/routesConstants";
import {
  fetchAssignedCarsNode,
  postRemoveAssignedCar,
} from "../../../../../redux/api/fleet.api";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";

function AssignCarsToNodeActionButton({
  itemId,
  crudData,
  tableContext,
}: {
  itemId: string;
  crudData: AssignedCarsNodeDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleTransferCar = () => {
    dispatch(setFleetAssignedCarToNode(crudData));
    navigate(`/${fleetRoutes.assignedCarNode}/transfer/${itemId}`);
  };

  const handleRemoveAssignedCar = async () => {
    const resultAction = await dispatch(
      postRemoveAssignedCar({ id_flota_nod: itemId }),
    );

    if (
      checkEndpointStatus(resultAction, postRemoveAssignedCar) ===
      endpointStatus.fulfilled
    ) {
      if (
        tableContext.tablePagination.page &&
        tableContext.tablePagination.rowsPerPage
      ) {
        dispatch(
          fetchAssignedCarsNode({
            page: tableContext.tablePagination.page,
            perPage: tableContext.tablePagination.rowsPerPage,
            nrauto: tableContext.tableSearch.nrauto,
            id_nod: tableContext.tableFilter.id_nod,
          }),
        );
      }
    }
  };

  return (
    <div>
      <CustomButton
        variant="contained"
        className="mt-1 me-1 py-2"
        tooltipTitle="Transfer masina"
        onClick={handleTransferCar}>
        <SvgIcon type="TRANSFER" />
      </CustomButton>

      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        tooltipTitle="Scoatere din evidenta"
        color="error"
        withConfirmationModal={{
          modalTitle: "Eliminare masina",
          modalSubtitle: `Doriti sa scoateti din evidenta masina cu nr. auto ${crudData.nrauto}`,
          modalLeftButtonVariant: "outlined",
          modalRightButtonOnClick: handleRemoveAssignedCar,
        }}>
        <SvgIcon type="DELETE" />
      </CustomButton>
    </div>
  );
}

export default AssignCarsToNodeActionButton;
